import {
    Image,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    Text,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
import SessionContext from '../contexts/SessionContext';
import OrganizationSwitcherPanel from './OrganizationSwitcherPanel';
import { Button, Icon } from '../ui';
import { checkboxMenuPopoverContentSx } from '../ui/primitives/CheckboxMenu';
import yaxleLogoMarkGray from '../assets/yaxleLogoMarkGray.svg';

/**
 * Persistent org switcher in the TopBar, for Yaxle employee accounts: shows the
 * customer org currently being viewed and opens the same searchable switcher the
 * account menu drills into. Hidden for customer accounts.
 */
const OrganizationSwitcherButton = () => {
    const sessionContext = useContext(SessionContext);
    const [isOpen, setIsOpen] = useState(false);

    const isInternal = sessionContext?.isAuthenticated === true && sessionContext.isInternal;
    if (!isInternal) return null;

    const organizationName = sessionContext?.organizationName || 'Select organization';

    return (
        <Popover
            placement="bottom-end"
            isOpen={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
        >
            <PopoverTrigger>
                <Button
                    variant="outlineSubtle"
                    size="toolbar"
                    aria-label="Switch organization"
                    leftIcon={<Image src={yaxleLogoMarkGray} alt="" boxSize="1.05rem" />}
                    rightIcon={
                        <Icon
                            name="chevronDown"
                            size="xs"
                            color="fg.muted"
                            transition="transform 200ms ease"
                            transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                        />
                    }
                >
                    <Text as="span" noOfLines={1} maxW={{ base: '110px', lg: '190px' }}>
                        {organizationName}
                    </Text>
                </Button>
            </PopoverTrigger>
            <Portal>
                <PopoverContent
                    w="320px"
                    maxW="calc(100vw - 24px)"
                    zIndex={2000}
                    sx={checkboxMenuPopoverContentSx}
                >
                    <PopoverBody p={0}>
                        <OrganizationSwitcherPanel onSwitched={() => setIsOpen(false)} />
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
};

export default OrganizationSwitcherButton;
